import { render, staticRenderFns } from "./formTestimonial.vue?vue&type=template&id=e150cc92&"
import script from "./formTestimonial.vue?vue&type=script&lang=js&"
export * from "./formTestimonial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports